import { useEffect } from 'react';
import { VoiceCard } from '@/components/voice/VoiceCard';
import { LanguageSelect } from '@/components/voice/LanguageSelect';
import { voices } from '@/data/voices';
import type { ContentFormData } from '..';

interface VoiceSelectProps {
  formData: ContentFormData;
  updateFormData: (data: Partial<ContentFormData>) => void;
  onValidationChange: (isValid: boolean) => void;
}

export function VoiceSelect({
  formData,
  updateFormData,
  onValidationChange
}: VoiceSelectProps) {
  // A preset (or a previous visit) may have already set the voice — validate
  // on mount so Next isn't stuck disabled without re-clicking.
  useEffect(() => {
    onValidationChange(!!formData.voice && formData.language === 'en');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.voice, formData.language, onValidationChange]);

  const handleVoiceSelect = (voiceId: string) => {
    updateFormData({ voice: voiceId });
    onValidationChange(!!voiceId && formData.language === 'en');
  };

  const handleLanguageChange = (value: string) => {
    updateFormData({ language: value });
    onValidationChange(!!formData.voice && value === 'en');
  };

  return (
    <div className="space-y-6">
      <LanguageSelect 
        value={formData.language} 
        onChange={handleLanguageChange} 
      />

      <div className="grid md:grid-cols-3 gap-4">
        {voices.map((voice) => (
          <VoiceCard
            key={voice.id}
            {...voice}
            isSelected={formData.voice === voice.id}
            onSelect={() => handleVoiceSelect(voice.id)}
          />
        ))}
      </div>
    </div>
  );
}